<template>
  <v-container fluid style="height:100%" pa-0 ma-0>
    <StaffTable></StaffTable>
  </v-container>  
</template>


<script>
import { mapFields,mapMultiRowFields } from 'vuex-map-fields'
import StaffTable from './../../components/blocks/StaffTable'


export default {
    components: {
      StaffTable
    },
    data () {
      return {
        autogrow:true,
        clipped: true,
        email: '',
        password: '',
        passwordConfirm: '',
        isTopBarFlat:true,
        clipped: true,
        clippedToolbar:true,
        alert: false,
        right: true,
        hideSlider:true,
        miniVariant: true,
        
      }
    },
    mounted() {
    },
    computed: {
      formTitle () {
      },
      ...mapFields([
        'settings.isAuthenticated',
        'settings.isSales',
        'settings.isOffice',
        'selectedView.officeView',
        'selectedView.salesView',
        'selectedView.clientView',
        'settings',
        'user',
        
      ]),
    },
    created () {},
    methods: {
      
      example(message) {
        
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/views/Staff.vue